/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewladdertitle3Inputs */

const en_letterpreviewladdertitle3 = /** @type {(inputs: Letterpreviewladdertitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where this fits in the escalation`)
};

const pt_letterpreviewladdertitle3 = /** @type {(inputs: Letterpreviewladdertitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde esta carta encaixa na escalada`)
};

/**
* | output |
* | --- |
* | "Where this fits in the escalation" |
*
* @param {Letterpreviewladdertitle3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewladdertitle3 = /** @type {((inputs?: Letterpreviewladdertitle3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewladdertitle3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewladdertitle3(inputs)
	return pt_letterpreviewladdertitle3(inputs)
});
export { letterpreviewladdertitle3 as "letterPreviewLadderTitle" }